import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack } from '@mantine/core';

import { Breadcrumbs, MetaTitle } from 'components/shared';
import type { OrganisationType } from 'types';

import { Header } from './Header';
import { Tabs } from './Tabs';

type Props = {
  organisation: OrganisationType | undefined;
  children: ReactNode;
};

export const OrganisationViewWrapper = ({ organisation, children }: Props) => {
  const { t } = useTranslation('organisations');
  return (
    <>
      <MetaTitle value={t('organisationManagement')} />
      <Breadcrumbs
        sx={theme => ({ marginBottom: theme.other.spacing(4.5) })}
        items={[
          { name: t('organisationManagement'), url: '#' },
          { name: organisation?.name || '', url: '#' },
        ]}
      />
      <Header />
      <Box
        sx={theme => ({
          background: 'white',
          borderRadius: theme.radius.sm,
          padding: theme.other.spacing(4),
          paddingTop: theme.other.spacing(3),
        })}
      >
        <Tabs />
        <Stack spacing="xl">{children}</Stack>
      </Box>
    </>
  );
};
